import { useLocation, useNavigate } from 'react-router-dom';
import { useSEO } from '~/hooks/useSEO';
import { NOT_FOUND_SEO } from '~/seo/site';
import './404.css';

const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const canBack = window.history.length > 1;

  useSEO(NOT_FOUND_SEO);

  return (
    <div className="nf-page">
      <main className="nf-card">
        <p className="nf-code">404</p>
        <h1>页面不存在</h1>
        <p className="nf-desc">这个地址没有对应的内容，可能已经调整，或链接不完整。可以回到首页继续浏览。</p>
        <p className="nf-path-label">当前地址</p>
        <p className="nf-path">{location.pathname + location.search}</p>
        <div className="nf-actions">
          <button type="button" className="nf-btn nf-btn_primary" onClick={() => navigate('/')}>
            返回首页
          </button>
          {canBack && (
            <button type="button" className="nf-btn nf-btn_ghost" onClick={() => navigate(-1)}>
              返回上一页
            </button>
          )}
        </div>
      </main>
    </div>
  );
};

export default ErrorPage;
